import 'components/branchIO';
import 'components/accessibilityGeneral.js';
import Header from 'components/header.js';
import Footer from 'components/footer.js';
import RedfastService from 'services/RedfastService';
import LazyLoad from 'vanilla-lazyload';
import 'helpers/tracking.js';
import 'shared/touch_devices_detection';
import 'shared/cbs.ui';
import 'shared/ad_utils';
import { setupDeviceIdCookie } from 'helpers/signOutOfDevices.js';

import deeplinkTracking from 'services/DeeplinkTracking';

import InAppMessagingTemp from 'shared/inAppMessagingTemp';
import { UpdateFocusable } from 'components/accessibilityGeneral';
import DMAService from '../services/DMAService.js';

import brazePushTracking from 'helpers/brazePushTracking';
import FallbackImageManager from 'helpers/fallbackImageManager';
import { saveTimeZone } from 'helpers/timeZone.js';

// VTD - video tracking debugger
import { Vtd } from '../video/shared/Vtd';
import { REDFAST_ENABLED } from 'helpers/featureConstants.js';
import Domain from 'helpers/Domain';
import { abTestUiTool } from './globalAbTestUiTool';
import { handleDeltaExtension } from '../helpers/deltaExtensionHandler';
import WatchlistService from '../services/WatchlistService.js';
import NotificationService from '../services/NotificationService.js';

// Devtool overlay
if (CBS.Registry.debuggable) {
    const openDevtools = (e) => {
        if (e.key === '`') {
            window.removeEventListener('keypress', openDevtools);
            import('@cbsi-cbscom/web-peak-tweak').then(({ default: addDrawerToDom }) =>
                addDrawerToDom(),
            );
        }
    };
    window.addEventListener('keypress', openDevtools);
}

window._vtd = new Vtd();

window._watchlistService = new WatchlistService();
window._notificationService = new NotificationService();

let inAppMessagingTemp = new InAppMessagingTemp();
inAppMessagingTemp.init();

if (CBS.Registry.Features.braze_sdk === true) {
    const brazeTrackingObj = new brazePushTracking();
    CBS.Tracking.utag_data = brazeTrackingObj.appendTrackingData(CBS.Tracking.utag_data);
    brazeTrackingObj.removeParamsFromUrl();
    (async () => {
        const Braze = (await import('shared/Braze')).default;
        new Braze();
    })();
}

if (CBS.Registry.Features[REDFAST_ENABLED]) {
    // register redfastService so we can use it globally and have only one instance
    CBS.Registry.redfastService = new RedfastService({
        apiDomain: CBS.Registry.redfast_api_domain,
        appId: CBS.Registry.redfast_app_id,
        locale: CBS.Registry.region.locale,
        subscriptionCountry: CBS.Registry.userSubscriptionCountry,
        userId: CBS.Registry.user?.id ?? '',
    });
}

let __header;
try {
    __header = new Header();
} catch (e) {
    console.error('Header component failed to load');
}

let lazyLoad = new LazyLoad({
    threshold: 50,
    elements_selector: '.lazy',
    callback_finish: () => {
        UpdateFocusable();
    },
    callback_error: (el) => {
        let parent = el.closest('.thumb-wrapper');
        let isCharacter = el.classList.contains('character-img');
        let isAvatar = el.closest('.avatar_picker_group_container') !== null;
        let fallbackImage = null;

        if (isAvatar) {
            fallbackImage = CBS.Registry.fallbackImage.avatar;
        } else if (parent && !isCharacter) {
            let poster = CBS.Registry.fallbackImage.poster;
            let landscape = CBS.Registry.fallbackImage.landscape;
            fallbackImage = FallbackImageManager.getFallBackImage(parent, poster, landscape);
        }
        if (el.dataset.src !== fallbackImage) {
            el.dataset.src = fallbackImage;
            CBS.Registry.lazyImage.resetElementStatus(el);
            CBS.Registry.lazyImage.update();
        }
    },
});

CBS.Registry.lazyImage = {
    resetElementStatus: (el) => lazyLoad.resetElementStatus(el),
    revalidate: () => lazyLoad.update(),
    update: () => lazyLoad.update(),
    load(element, force) {
        if (element && element.length !== undefined) {
            for (let i = 0; i < element.length; i++) {
                this.load(element[i]);
            }
        } else {
            lazyLoad.load(element, force);
        }
    },
};

if (CBS.Registry.bn) {
    console.log(CBS.Registry.bn);
}

(function () {
    let images = document.querySelectorAll('img');

    for (var i = 0; i < images.length; i++) {
        let img = images[i];
        img.onerror = () => {
            let parent = img.closest('.show-image');

            if (parent) {
                let fallbackImage = FallbackImageManager.getFallBackImage(
                    parent,
                    CBS.Registry.fallbackImage.poster,
                    CBS.Registry.fallbackImage.landscape,
                );
                img.removeAttribute('srcset');
                img.src = fallbackImage;
            }
            img.onerror = null;
        };
    }
})();

// setup ab test ui tool
abTestUiTool();
// prevents chrome's Delta extension styling conflicts
handleDeltaExtension();

// Save time zone for server side requests
saveTimeZone();

// Support Sign-out of individual devices
setupDeviceIdCookie();
